import { toast } from "@/state/hooks";
import * as Sentry from "@sentry/browser";
import { Button } from "@/ui/components/ui/button";
import { Card, CardContent } from "@/ui/components/ui/card";
import { useActions } from "@/state/legacy_module_api";

const NotificationsPanel = () => {
  const { registerPlatformPushToken } = useActions();

  const handleRegisterPush = async () => {
    try {
      await registerPlatformPushToken();
      toast.success("Push notifications registered successfully!");
    } catch (error) {
      console.error("Failed to register push notifications:", error);
      Sentry.captureException(error);
      toast.error("Failed to register push notifications. Please try again.");
    }
  };

  return (
    <div className="h-full overflow-auto space-y-4 p-4">
      <Card>
        <CardContent className="pt-6">
          <h2 className="text-xl font-semibold mb-4">Notifications</h2>
          <p className="text-muted-foreground mb-4">
            Enable push notifications to receive alerts when you have new
            messages.
          </p>
          <Button onClick={handleRegisterPush} className="w-full">
            Register Push Notifications
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotificationsPanel;
